import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { IVisitData } from './emr-general-methods';
import { IMedicalData, EmrPatVitals, PannerData } from './medical-recored.interfaces';
import { PatientVM } from '../registeration/patients';
import { HttpClient } from '@angular/common/http';
import { EmrTaps } from './emr-taps/emr-taps.service';

@Injectable({
  providedIn: 'root'
})
export class MedicalRepositoryService {
  constructor(private _http: HttpClient) { }
  // special for vitals component
  EmrVitalDataList: {
    bloodPressure: boolean,
    bloodSuger: boolean,
    headCircumference: boolean,
    height: boolean,
    pluse: boolean,
    respiration: boolean,
    weight: boolean,
    specialityId: number

  }[] = [];
  moduleSettingData:any={}
  ////////////////////////////////////////////////////////
  claimFormId: number;

  clinicCode: number;

  emrMedicalDataRepo: IMedicalData = <IMedicalData>{};

  VisitSerial: number;
  PatientCode: number;

  VisitData: IVisitData = <IVisitData>{};
  PatientData: PatientVM | any = <PatientVM | any>{};

  VitalsData: EmrPatVitals[] = [];
  FavoriteList: any[] = [];
  profileTabs: EmrTaps[] = [];
  editableContent: boolean;

  get getPatientInfo(): PatientVM | any {
    return this.PatientData;
  }

  get getEmrDoctorsData(): IMedicalData {
    return this.emrMedicalDataRepo;
  }


  get nphiesSpecialtyID() {
    return sessionStorage.getItem('nphiesSpecialtyID');
  }

  _pannerData$: BehaviorSubject<PannerData> = new BehaviorSubject<PannerData>(<PannerData>{});
  setPannerData(panner: PannerData) {
    // prepare adrress for view in right way
    panner.fullAddressAr = panner.fullAddressAr && panner.fullAddressAr.length > 0 ? panner.fullAddressAr : panner.altAddressAr;
    panner.fullAddressEn = panner.fullAddressEn && panner.fullAddressEn.length > 0 ? panner.fullAddressEn : panner.altAddressEn;
    this.emrMedicalDataRepo.PannerData = panner;
    this._pannerData$.next(panner);
  }

  _fireEmrGetData$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  fireEmrGetData(patient: any) {
    this._fireEmrGetData$.next(patient);
  }


  private _sharedData: BehaviorSubject<any> = new BehaviorSubject<any>(<any>{});
  sharedMedicalData$ = this._sharedData.asObservable();
  setSharedMedicalData(shared: any) {
    this._sharedData.next(shared);
  }

  reloadSubscription: Subscription;
  _reloadClick: EventEmitter<string> = new EventEmitter<string>();
  reloadBlockData(value: string) {
    this._reloadClick.emit(value);
  }

  resetRepoeistory() {
    this.setPannerData({} as PannerData);
    this.EmrVitalDataList = [];
    this.claimFormId = null;
    this.clinicCode = null;
    this.emrMedicalDataRepo = <IMedicalData>{};
    this.VisitSerial = null;
    this.PatientCode = null;
    this.VisitData = <IVisitData>{};
    this.PatientData = <PatientVM | any>{};
    this.VitalsData = null;
    this.editableContent = null;
  }

  readJsonFile(url: string) {
    return this._http.get(url);
  }
  controlRelodBlockData(tapName: string) {
    if (tapName == 'ORDERHISTORY' || tapName == 'ORDERS' || tapName == 'MED_NURSING' || tapName == 'SCORES' || tapName == 'CAF'
      || tapName == 'NU-CARE' || tapName == 'Vitals' || tapName == 'Consultation' || tapName == 'History' || tapName == 'NOTES' || tapName == 'PATDOCS') {
      return 0
    } else if (tapName == 'Vitals') {
      return 1
    } else {
      return 1
    }
  }

}
